import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../../components/common/InputComp/Input";
import TabComp from "../../../../components/TabsComp/TabComp";
import Btn from "../../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../../utils/asyncStatus";
import { primaryColor } from "../../../../utils/themeColors";
import {
  addProductStyleAsync,
  addProductFabricTypeAsync,
  deleteProductFabricTypeAsync,
  editProductStyleAsync,
  editProductFabricTypeAsync,
  getProductStyleAsync,
  getProductFabricTypeAsync,
} from "../../../../store/services/productInfoServices";
const FabricType = () => {
  const dispatch = useDispatch();
  const {
    getProductFabricTypeStatus,
    getProductFabricTypeError,
    getProductFabricTypeData,
    addProductFabricTypeStatus,
    addProductFabricTypeData,
    addProductFabricTypeError,

    editProductFabricTypeStatus,
    editProductFabricTypeError,
    editProductFabricTypeData,

    deleteProductFabricTypeData,
    deleteProductFabricTypeStatus,
    deleteProductFabricTypeError,
  } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(getProductFabricTypeAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getProductFabricTypeData?.length
    ? getProductFabricTypeData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedFabricType, setSelectedFabricType] = useState();
  const [addFabricTypeMode, setAddFabricTypeMode] = useState(false);
  const [addFabricTypeData, setAddFabricTypeData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedFabricType", selectedFabricType);
  // console.log("editData", editData);
  useEffect(() => {
    if (addProductFabricTypeStatus === asyncStatus.SUCCEEDED) {
      setAddFabricTypeMode(false);
      setSaveDisabled(true);
      setAddFabricTypeData();
    }
  }, [, addProductFabricTypeStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteProductFabricTypeAsync(selectedFabricType?.fabric_type_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteProductFabricTypeStatus === asyncStatus.SUCCEEDED) {
      setOpen(false);
      setSelectedFabricType();
    }
  }, [, deleteProductFabricTypeStatus]);
  useEffect(() => {
    if (editProductFabricTypeStatus === asyncStatus.SUCCEEDED) {
      setSelectedFabricType();
      setEditMode(false);
    }
  }, [, editProductFabricTypeStatus]);
console.log("getProductFabricTypeData",getProductFabricTypeData,editProductFabricTypeData);
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this fabric type?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Fabric Type"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Fabric Type Name
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddFabricTypeMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addFabricTypeMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addFabricTypeMode || !selectedFabricType}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddFabricTypeMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addFabricTypeMode || !selectedFabricType}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addProductFabricTypeStatus === asyncStatus.LOADING ||
                  editProductFabricTypeStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addFabricTypeData) {
                    dispatch(addProductFabricTypeAsync(addFabricTypeData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedFabricType, ...editData };
                    delete a.id;
                    dispatch(editProductFabricTypeAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={"500px"} width={"100%"}>
              <TableComp
                columns={[
                  { field: "fabric_type_id", headerName: "ID", flex: true },
                  {
                    field: "fabric_type_name",
                    headerName: "Fabric Type Name",
                    flex: true,
                  },
                ]}
                onRowClick={(e) => {
                  setSelectedFabricType(e?.row);
                }}
                rows={formattedData}
                loading={
                  getProductFabricTypeStatus === asyncStatus.IDLE ||
                  getProductFabricTypeStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addFabricTypeMode ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "Fabric Type:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddFabricTypeData({
                            ...addFabricTypeData,
                            fabric_type_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddFabricTypeData({
                            ...addFabricTypeData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedFabricType ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedFabricType?.fabric_type_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "Fabric Type:",
                    comp: (
                      <InputComp
                        key={selectedFabricType?.fabric_type_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            fabric_type_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedFabricType?.fabric_type_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={editData?.is_active}
                        disabled={!editMode}
                        defaultValue={
                          selectedFabricType?.is_active ? true : false
                        }
                        defaultChecked={
                          selectedFabricType?.is_active ? true : false
                        }
                        checked={selectedFabricType?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (
              <Typography>Select any Fabric Type</Typography>
            )}

            <Stack>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {getProductFabricTypeError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {addProductFabricTypeError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {editProductFabricTypeError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {deleteProductFabricTypeError}
              </Typography>
            </Stack>
            <Stack my={2}>
              <TabComp
                tabs={[
                  {
                    name: "Companies",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "companyId",
                              headerName: "Company ID",
                              flex: true,
                            },
                            {
                              field: "companyName",
                              headerName: "Company Name",
                              flex: true,
                            },
                            {
                              field: "action",
                              headerName: "Action",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedFabricType(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedFabricType(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default FabricType;
